import React, { Fragment, useState, useEffect } from "react";
import { Link } from "react-router-dom";

import { useAlert } from "react-alert";

import { useDispatch, useSelector } from "react-redux";
import { createFaq, clearErrors } from "../../../actions/faqActions";
import { NEW_FAQ_RESET } from "../../../constants/faqConstants";

import Loader from "../../Loader";

const NewFAQ = ({ history }) => {
  const alert = useAlert();
  const dispatch = useDispatch();

  const [faq, setFaq] = useState({
    question: "",
    answer: "",
    status: false,
  });
  const [validationErrors, setValidationErrors] = useState({});
  const [errorData, setErrorData] = useState({});

  const { question, answer, status } = faq;

  const { loading, success, error, errors } = useSelector(
    (state) => state.newFaq
  );

  useEffect(() => {
    if (errors) {
      setErrorData(errors);
    }

    if (error) {
      clearErrors();
      return alert.error(error);
    }

    if (success === true && success != undefined) {
      alert.success("FAQ successfully added.");
      history.push("/admin/faqs");
      dispatch({
        type: NEW_FAQ_RESET,
      });
    }
  }, [dispatch, success, alert, error, errors]);

  const onChange = (e) => {
    if (e.target.name === "status") {
      setFaq({
        ...faq,
        status: !status,
      });
    } else {
      setFaq({
        ...faq,
        [e.target.name]: e.target.value,
      });
    }

    // Clear validation error when user types
    if (validationErrors[e.target.name]) {
      setValidationErrors({
        ...validationErrors,
        [e.target.name]: "",
      });
    }
  };

  const validateForm = () => {
    const errors = {};

    // Question validation
    if (!question.trim()) {
      errors.question = "Question field is required";
    } else if (question.length > 500) {
      errors.question = "Question cannot exceed 500 characters";
    }

    // Answer validation
    if (!answer.trim()) {
      errors.answer = "Answer field is required";
    }

    setValidationErrors(errors);

    // Return true if no errors, false otherwise
    return Object.keys(errors).length === 0;
  };

  const submitHandler = (e) => {
    e.preventDefault();

    // Validate form before submitting
    if (validateForm()) {
      dispatch(createFaq({ question, answer, status }));
    } else {
      alert.error("Please fix the validation errors");
    }
  };

  return (
    <Fragment>
      {loading ? (
        <Loader />
      ) : (
        <Fragment>
          <div className="content-wrapper">
            <section className="content-header">
              <h1>
                Add
                <small>FAQ</small>
              </h1>
              <ol className="breadcrumb">
                <li>
                  <Link to="/admin">
                    <i className="fa fa-dashboard"></i> Dashboard
                  </Link>
                </li>
                <li>
                  <Link to="/admin/faqs">
                    <i className="fa fa-table"></i> FAQs
                  </Link>
                </li>
                <li className="active">Add FAQ</li>
              </ol>
            </section>

            <section className="content">
              <div className="box box-default">
                <div className="box-header with-border">
                  <h3 className="box-title">Add FAQ</h3>
                </div>

                <form id="quickForm" onSubmit={submitHandler}>
                  <div className="box-body">
                    <div className="form-group row">
                      <div className="col-md-12">
                        <label htmlFor="question">
                          Question <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          name="question"
                          className={`form-control ${
                            validationErrors.question ? "is-invalid" : ""
                          }`}
                          id="question"
                          placeholder="Enter the FAQ question"
                          value={question}
                          onChange={onChange}
                        />
                        {validationErrors.question ? (
                          <span className="text-danger">
                            {validationErrors.question}
                          </span>
                        ) : errorData.question ? (
                          <span className="text-danger">
                            {errorData.question}
                          </span>
                        ) : (
                          ""
                        )}
                        <small className="form-text text-muted">
                          Maximum 500 characters allowed
                        </small>
                      </div>
                    </div>
                    <div className="form-group row">
                      <div className="col-md-12">
                        <label htmlFor="answer">
                          Answer <span className="text-danger">*</span>
                        </label>
                        <textarea
                          name="answer"
                          className={`form-control ${
                            validationErrors.answer ? "is-invalid" : ""
                          }`}
                          id="answer"
                          rows="6"
                          placeholder="Enter the FAQ answer"
                          value={answer}
                          onChange={onChange}
                        ></textarea>
                        {validationErrors.answer ? (
                          <span className="text-danger">
                            {validationErrors.answer}
                          </span>
                        ) : errorData.answer ? (
                          <span className="text-danger">
                            {errorData.answer}
                          </span>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>

                    <div className="form-group row">
                      <div className="col-md-6">
                        <label htmlFor="status">Status</label>
                        <input
                          style={{ marginRight: "5px" }}
                          type="checkbox"
                          className="form-check-input"
                          id="status"
                          name="status"
                          checked={status}
                          value={status}
                          onChange={onChange}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="box-footer">
                    <button type="submit" className="btn btn-primary">
                      Submit
                    </button>
                  </div>
                </form>
              </div>
            </section>
          </div>
        </Fragment>
      )}
    </Fragment>
  );
};

export default NewFAQ;
